import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Vars
        this.classname = this.el.dataset.classname

        // Events
        this.events = {
            click: {
                'toggler': 'toggle'
            }
        }
    }


    toggle() {
        this.el.classList.toggle(this.classname)
    }
}
